<section>
  <div class="row">
    <!-- lado izquierdo -->
    <nav id="sidebarMenu" class="col-md-2 col-lg-2  d-md-block bg-light sidebar collapse">
      <div class="position-sticky pt-3 table-responsive">
        <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" routerLink="">
              DASHBOARD
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link active" routerLink="/administradores">
              Administradores
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/administradores/coordinadores">
              Coordinadores
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/usuarios">
              Usuarios
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/organizadores">
              Organizadores
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/administradores/admin/eventos/lista">
              Eventos
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/administradores/admin/ciudades/lista">
              Ciudades
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/administradores/puntosFisicos">
              Puntos Fisicos
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="mapas">
              Mapas De Eventos
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/administradores/ministerios">
              Ministerios
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/administradores/promotores">
              Promotores
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <nav class="menu-mobile">
      <ul class=" flex-column">
        <li class="">
          <a  routerLink="">
            DASHBOARD
          </a>
        </li>
        <li >
          <a  routerLink="/administradores">
            Administradores
          </a>
        </li>
        <li >
          <a  routerLink="/administradores/coordinadores">
            Coordinadores
          </a>
        </li>
        <li >
          <a  routerLink="/usuarios">
            Usuarios
          </a>
        </li>
        <li >
          <a routerLink="/organizadores">
            Organizadores
          </a>
        </li>
        <li >
          <a  routerLink="/administradores/admin/eventos/lista">
            Eventos
          </a>
        </li>
        <li >
          <a  routerLink="/administradores/admin/ciudades/lista">
            Ciudades
          </a>
        </li>
        <li >
          <a  routerLink="/administradores/puntosFisicos">
            Puntos Fisicos
          </a>
        </li>
        <li >
          <a  routerLink="mapas">
            Mapas De Eventos
          </a>
        </li>
        <li >
          <a  routerLink="/administradores/ministerios">
            Ministerios
          </a>
        </li>
        <li >
          <a  routerLink="/administradores/promotores">
            Promotores
          </a>
        </li>
      </ul>
    </nav>
    <!-- lado derecho -->
    <main class="col-md-9 px-md-4">
      <div class="row-1">
        <!-- <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4">-->
        <div
          class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h2>Analitics</h2>
        </div>
        <div class="row mt-2">
          <div class="col-sm-4">
            <!--<img src="https://images.pexels.com/photos/10581443/pexels-photo-10581443.jpeg?cs=srgb&dl=pexels-nikita-igonkin-10581443.jpg&fm=jpg" width="100%">-->
            <div class="infoDate">
              <i class="bi bi-app"></i>
              <span>$2.750<br>Lorem ipsum
              </span>
            </div>
          </div>
          <div class="col-sm-4">
            <!--<img src="https://images.pexels.com/photos/10581443/pexels-photo-10581443.jpeg?cs=srgb&dl=pexels-nikita-igonkin-10581443.jpg&fm=jpg" width="100%">-->
            <div class="infoDate">
              <i class="bi bi-app"></i>
              <span>$750<br>Lorem ipsum
              </span>
            </div>
          </div>
          <div class="col-sm-4">
            <!--<img src="https://images.pexels.com/photos/10581443/pexels-photo-10581443.jpeg?cs=srgb&dl=pexels-nikita-igonkin-10581443.jpg&fm=jpg" width="100%">-->
            <div class="infoDate">
              <i class="bi bi-app"></i>
              <span>$5.450<br>Lorem ipsum
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row-2">
        <h2>Reports</h2>
        <div class="row mt-2">
          <div class="col-sm-12 col-md-6">
            <img src="https://www.cuadernosdeperiodistas.com/media/2014/05/porcentaje.jpg" width="100%">
          </div>
          <div class="col-sm-12 col-md-6">
            <img
              src="https://docs.tibco.com/pub/spotfire_web_player/6.0.0-november-2013/es-ES/WebHelp/GUID-418B2936-C878-4771-B874-FA8ECAA39941-display.png"
              width="100%">
          </div>
        </div>
      </div>
    </main>
  </div>
</section>